import React from "react";
import Select from "react-dropdown-select";
import { string, func, bool, array } from "prop-types";
import styles from "./SelectField.module.scss";

const SelectField = ({
  id,
  name,
  required,
  options,
  placeholder,
  handleChange,
  inputStyle,
  fieldStyle,
}) => {
  return (
    <div className={fieldStyle || styles.selectField}>
      <Select
        id={id}
        name={name}
        closeOnSelect
        required={required}
        searchable={false}
        dropdownHeight="150px"
        placeholder={placeholder}
        className={inputStyle || styles.reactDropdownSelect}
        options={options}
        onChange={values =>
          handleChange({ currentTarget: { name, value: values[0] } })
        }
      />
    </div>
  );
};

SelectField.propTypes = {
  id: string,
  name: string,
  required: bool,
  handleSetValue: func,
  placeholder: string,
  options: array,
};

SelectField.defaultProps = {
  required: false,
};

export default SelectField;
